/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


document.addEventListener('variant:changed', function (event) {
  var variant = event.detail.variant;
  var notifyWrapper = document.querySelector('.notify-me-wrapper');
  var addToCart = document.querySelector('.product-form__add-button');

  if (!notifyWrapper || !addToCart) return;

  if (variant && variant.available === false) {
    notifyWrapper.style.display = 'block';
    addToCart.style.display = 'none';
  } else {
    notifyWrapper.style.display = 'none';
    addToCart.style.display = 'block';
  }
});



document.addEventListener('click', function (e) {
  var notifyButton = e.target.closest('[data-notify-wrapper] button');
  if (notifyButton) {
    e.stopImmediatePropagation();
  }
}, true);
